module.exports = __webpack_public_path__ + "img/3.bc41fc96.png";